// extracted by mini-css-extract-plugin
module.exports = {"title":"PrivacyPolicy-module--title--obJpG","body":"PrivacyPolicy-module--body--2m_tk"};